var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Box, LinearProgress, Typography } from '@mui/material';
import { cuppingComment as api } from '../../../../api';
import { useRequest } from '../../../../hooks/requestHook';
import { getCurrentUser } from '../../../../localStorage';
import FullScreenDialog from '../../../molecules/FullScreenDialog';
import { CommentBox as OrigianalCommentBox, CommentsBox, } from '../../../organisms/CuppingComments/CommentBox';
import Comment from '../../../organisms/CuppingComments/Comment';
import Button from '../../../atoms/BaseButton';
import { useConfirm } from '../../../../hooks/confirmationHook';
import CuppingCommentForm from './CuppingCommentForm';
var CommentBox = styled(OrigianalCommentBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .actions {\n    display: flex;\n    justify-content: flex-end;\n  }\n"], ["\n  .actions {\n    display: flex;\n    justify-content: flex-end;\n  }\n"])));
var CuppingCommentsDialog = function (_a) {
    var offer = _a.offer, onClose = _a.onClose, onChangeOffer = _a.onChangeOffer;
    var t = useTranslation().t;
    var currentUser = getCurrentUser();
    var getCuppingComments = useRequest(api.getAll);
    var deleteCuppingComment = useRequest(api.destroy);
    var confirm = useConfirm();
    var _b = React.useState(), cuppingComments = _b[0], setCuppingComments = _b[1];
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!offer)
                            return [2 /*return*/];
                        return [4 /*yield*/, getCuppingComments({
                                q: { offer_id_eq: offer.id },
                            })];
                    case 1:
                        response = _a.sent();
                        if (canceled || !response)
                            return [2 /*return*/];
                        setCuppingComments(response.data.map(function (cuppingComment) { return (__assign(__assign({}, cuppingComment), { editing: false })); }));
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [offer, getCuppingComments]);
    var startEdit = React.useCallback(function (cuppingComment) {
        setCuppingComments(function (oldComments) {
            if (!oldComments)
                return;
            var editingCuppingComment = __assign(__assign({}, cuppingComment), { editing: true });
            return oldComments.map(function (comment) {
                return comment.id === cuppingComment.id ? editingCuppingComment : comment;
            });
        });
    }, []);
    var endEdit = React.useCallback(function (cuppingComment) {
        setCuppingComments(function (oldComments) {
            if (!oldComments)
                return;
            var editedCuppingComment = __assign(__assign({}, cuppingComment), { editing: false });
            return oldComments.map(function (comment) {
                return comment.id === cuppingComment.id ? editedCuppingComment : comment;
            });
        });
        onChangeOffer(cuppingComment.offer);
    }, [onChangeOffer]);
    var startDelete = React.useCallback(function (cuppingComment) { return __awaiter(void 0, void 0, void 0, function () {
        var title, body;
        return __generator(this, function (_a) {
            title = t('messages.deleteCommentConfirmTitle');
            body = t('messages.deleteCommentConfirmBody');
            confirm(title, body, function () { return __awaiter(void 0, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, deleteCuppingComment({ id: cuppingComment.id })];
                        case 1:
                            response = _a.sent();
                            if (!response)
                                return [2 /*return*/];
                            setCuppingComments(function (oldComments) {
                                if (!oldComments)
                                    return;
                                return oldComments.filter(function (comment) { return comment.id !== cuppingComment.id; });
                            });
                            onChangeOffer(response.offer);
                            return [2 /*return*/];
                    }
                });
            }); });
            return [2 /*return*/];
        });
    }); }, [t, confirm, deleteCuppingComment, onChangeOffer]);
    var addComment = React.useCallback(function (cuppingComment) {
        var addedCuppingComment = __assign(__assign({}, cuppingComment), { editing: false });
        setCuppingComments(function (oldComments) {
            if (!oldComments)
                return;
            return __spreadArray(__spreadArray([], oldComments, true), [addedCuppingComment], false);
        });
        onChangeOffer(cuppingComment.offer);
    }, [onChangeOffer]);
    var showNewForm = React.useMemo(function () {
        if (!cuppingComments)
            return true;
        return !cuppingComments.some(function (comment) { return comment.user.id === currentUser.id; });
    }, [cuppingComments]);
    var title = React.useMemo(function () {
        if (!offer)
            return 'Loading...';
        var cuppingScoreAverage = offer.cuppingScoreAverage;
        if (!cuppingScoreAverage)
            return "Cuppoing comment for ".concat(offer === null || offer === void 0 ? void 0 : offer.lotNumber);
        return "Cuppoing comment for ".concat(offer.lotNumber, " (").concat(t('params.offer.cuppingScoreAverage'), ": ").concat(cuppingScoreAverage, ")");
    }, [t, offer]);
    return (React.createElement(FullScreenDialog, { title: title, open: Boolean(offer), onClose: onClose },
        cuppingComments === undefined && React.createElement(LinearProgress, null),
        cuppingComments && (React.createElement(React.Fragment, null,
            React.createElement(CommentsBox, null,
                cuppingComments.length === 0 && (React.createElement(Typography, null, t('pages.roasterOrder.noComments'))),
                cuppingComments.map(function (comment) {
                    if (comment.editing) {
                        return (React.createElement(CuppingCommentForm, { key: comment.id, offerId: comment.offer.id, comment: comment, onSubmit: endEdit, onCancel: endEdit }));
                    }
                    return (React.createElement(CommentBox, { key: comment.id },
                        React.createElement(Comment, { comment: comment }),
                        React.createElement(Box, { className: "actions" },
                            React.createElement(Button, { variant: "text", size: "small", onClick: function () { return startEdit(comment); } }, "Edit"),
                            React.createElement(Button, { variant: "text", size: "small", color: "error", onClick: function () { return startDelete(comment); } }, "Delete"))));
                })),
            showNewForm && (React.createElement(React.Fragment, null,
                React.createElement(Typography, { variant: "h3" }, "New Comment"),
                React.createElement(CuppingCommentForm, { offerId: (offer === null || offer === void 0 ? void 0 : offer.id) || '', onSubmit: addComment })))))));
};
export default CuppingCommentsDialog;
var templateObject_1;
